// Canonical KLYROO article taxonomy — single source of truth on the frontend,
// mirroring backend research_ai.ARTICLE_CONTENT_TYPES / PRIMARY_VERTICALS. Used by the
// public category filters, the article editor and the admin CMS so every surface shares
// the exact same values and capitalization.
export const CONTENT_TYPES = ["News", "Analysis", "Explainer", "Guide", "Review"];
export const PRIMARY_VERTICALS = ["AI", "Tech", "Gaming", "Reviews", "Guides"];

// A stored content_type is "canonical" when it exactly matches one of the 5 formats.
export const isCanonicalType = (v) => CONTENT_TYPES.includes(String(v || "").trim());
